import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=9685ec30&scoped=true"
var script = {}
import style0 from "./TextButton.vue?vue&type=style&index=0&id=9685ec30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9685ec30",
  null
  
)

export default component.exports